(function ($) {
    $(document).on('click', '.close-modal', function (e) {
        e.preventDefault();
        hideModal();
    });

    function hideModal() {
        $(".modal--open").removeClass("modal--open-load");
        $(".dialog.opened").removeClass("opened");

        setTimeout(function () {
            $(".modal--open").removeClass("modal--open");
            $("body").removeClass('has-modal');
        }, 200);
    }

})(jQuery);